<template>


    <div class="grid grid-cols-8 gap-4 mb-4" v-for="(item,index) in emiStructure" :key="index">

        <div class="col-span-2 sm:col-span-2">
            <breeze-label :value="'Amount'"/>
            <breeze-input :disabled="item.status" required type="number" :value="item.amount"
                          class="w-full"/>
        </div>
        <div class="col-span-2 sm:col-span-2">
            <breeze-label :value="'Due Date'"/>
            <breeze-input :disabled="item.status" type="date" :value="item.due_date" class="w-full"/>
        </div>
        <div class="col-span-2 sm:col-span-2">
            <breeze-label :value="'End Date'"/>
            <breeze-input :disabled="item.status" type="date" :value="item.end_date" class="w-full"/>
        </div>


        <div class="col-span flex items-end pb-2">
            <breeze-button v-if="item._id && emiNew==item._id" :disabled="item?.status ? true : false"
                           type="button"
                           @click="payEmi(item)" class="mr-2">
                {{ item.status ? 'Paid' : 'Pay Emi' }}
            </breeze-button>
            <a v-else-if="item.fee_receipt" class="inline-flex items-center px-4 py-2  border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none
     focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150 bg-gray-800 "
               :href="item.fee_receipt" target="_blank">
                View receipt
            </a>

        </div>
    </div>
    <PopupModel v-model="isView" button-name="Pay Emi" @confirm="submitEmit">
        <a v-if="emiId.fee_receipt" class="inline-flex items-center px-4 py-2  border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none
     focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150 bg-gray-800 "
           :href="emiId.fee_receipt" target="_blank">
            View receipt
        </a>
        <p v-else>
            Emi receipt not uploaded
        </p>

    </PopupModel>
</template>
<script setup>
import BreezeInput from '@/Components/Input'
import BreezeLabel from '@/Components/Label'
import BreezeButton from '@/Components/Button'
import BreezeInputError from '@/Components/InputError'
import {useForm} from '@inertiajs/inertia-vue3'
import {computed, ref} from "vue";
import PopupModel from "@/Components/PopupModel";

const emiNew = ref();
const branchid = ref(localStorage.branchId);

const props = defineProps({
    emis: {
        type: Object,
        default: []
    },
    admission: {
        type: Object,
        default: []
    },
})
const emiData = ref(props.emis);
const emiStructure = computed(() => {
    var emit_data = [];
    emiData.value.map((item) => {
        if (!emiNew.value && !(item.status)) {
            emiNew.value = item._id;
        }
        emit_data.push(item);
    });
    return emit_data;
})
const emptyForm = useForm({});

const isView = ref(false);
const emiId = ref(true);

function payEmi(item) {
    emiId.value = item;
    isView.value = true;
}

function submitEmit() {
    emptyForm.post(route('internal.admission.students.fees.pay', [branchid.value, props.admission?._id, emiId.value._id]), {
        onSuccess: (resp) => {
            isView.value = false;
            emiNew.value = '';
            emiData.value = resp.props.admissionFees;
        }
    })
}
</script>
